<template>
  <v-card>
    <v-container grid-list-sm fluid>
      <v-layout row wrap align-center>
        <template v-for="file in mediaItems">
          <v-flex :key="file.id" xs4>
            <v-card flat tile class="">
              <v-card-text class="grey lighten-5">
                <v-flex xs7>
                  <span
                    v-if="file.custom_properties.stage == 'complete'"
                    class="caption"
                    >Complete</span
                  >
                  <span
                    v-if="file.custom_properties.stage == 'start'"
                    class="caption"
                    >Before</span
                  >
                </v-flex>
                <v-flex xs1>
                  <v-icon
                    color="red"
                    absolute
                    dark
                    fab
                    top
                    right
                    medium
                    :disabled="
                      file.custom_properties.stage == 'start' ? true : false
                    "
                    @click.stop="deleteDialog(file)"
                    >delete</v-icon
                  >
                </v-flex>

                <v-img
                  :src="file.url ? file.url : file.src"
                  aspect-ratio="1"
                  class="grey lighten-2 media"
                  v-if="file.type == 'image'"
                  @click="openDialog(file)"
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-linear
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-linear>
                  </v-layout>
                </v-img>
                <video
                  height="100%"
                  width="100%"
                  :src="file.url ? file.url : file.src"
                  class="media"
                  @click="openDialog(file)"
                  v-else
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-linear
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-linear>
                  </v-layout>
                </video>

                <v-tooltip bottom>
                  <span slot="activator" class="description">{{
                    file.description
                  }}</span>
                  <span>{{ file.description }}</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <v-img
            :src="
              this.dialogFile.url ? this.dialogFile.url : this.dialogFile.src
            "
            v-if="this.dialogFile.type == 'image'"
            contain
            style="max-height:50vh"
          >
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <v-progress-linear
                indeterminate
                color="grey lighten-5"
              ></v-progress-linear>
            </v-layout>
          </v-img>

          <video
            height="100%"
            width="100%"
            :src="
              this.dialogFile.url ? this.dialogFile.url : this.dialogFile.src
            "
            autoplay
            controls
            v-else
          ></video>
          <v-textarea
            solo
            name="description"
            label="Description"
            v-model="description"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" fab bottom left dark @click="closeDialog"
            ><v-icon>close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="green" fab bottom right dark @click.native="saveMedia()"
            ><v-icon>save</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <delete-dialog
      preset="delete"
      ref="deleteDialog"
      v-on:deleted="deleteMediaConfirmed"
    ></delete-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Dialog from './Dialog'
export default {
  name: 'MediaList',
  components: { 'delete-dialog': Dialog },
  props: ['mediaItems'],
  data() {
    return {
      dialog: false,
      dialogFile: {},
      deleteDialogFlag: false,
      description: ''
    }
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId'
    })
  },
  mounted() {
    //
  },
  methods: {
    ...mapActions({
      readCalls: 'calls/readCalls',
      readCall: 'calls/readCall',
      addMedia: 'calls/addMedia',
      updateMedia: 'calls/updateMedia',
      deleteMedia: 'calls/deleteMedia'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    getMediaList(call) {
      return call.media || {}
    },

    openDialog(file) {
      this.dialog = true
      this.dialogFile = file
      this.description = file.description
    },

    closeDialog(file) {
      this.dialog = false
      this.dialogFile = {}
    },
    // Show delete dialog
    deleteDialog(file) {
      this.$refs.deleteDialog.open(file)
    },
    // Delete confirmed
    deleteMediaConfirmed(media) {
      this.deleteMedia(media).then(() => {
        // this.readCall(media.model_id)
        this.setNotification(this.$vuetify.t('$vuetify.calls.mediaDeleted'))
      })
    },
    saveMedia() {
      const media = this.dialogFile
      // media.description = this.description
      this.updateMedia({
        media: media,
        params: {
          description: this.description
        }
      }).then(() => {
        this.setNotification(this.$vuetify.t('$vuetify.calls.mediaUpdated'))
        this.dialog = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.actions {
  display: flex;
  align-items: center;
  .v-btn {
    margin: 0;
    width: 30px;
    height: 30px;
  }
}
.media {
  cursor: pointer;
}
.description {
  color: #888;
  display: block;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
